<template>
  <Guide :titleList="titleList" :isHasChild="true">
    <template #innerContent>
      <div class="setting-guide-page">
        <div class="setting-guide-page__spacer"></div>

        <slot
          name="renderer"
          :blocks="introBlocks"
          :image-map="imageMap"
          :section="null"
        />

        <section
          v-for="section in sections"
          :id="section.id"
          :key="section.id"
          class="setting-guide-page__section"
        >
          <CollapseItem
            :title="t(section.titleKey)"
            :level="1"
            v-model:visible="expandedSections[section.id]"
          >
            <div class="setting-guide-page__section-content">
              <slot
                name="renderer"
                :blocks="section.blocks"
                :image-map="imageMap"
                :section="section"
              />
            </div>
          </CollapseItem>
        </section>
      </div>
    </template>
  </Guide>
</template>

<script setup>
import {computed, reactive} from "vue";
import {useI18n} from "vue-i18n";
import Guide from "@/views/FileDoc/components/Guide.vue";
import CollapseItem from "@/views/FileDoc/components/CollapseItem.vue";

const props = defineProps({
  introBlocks: {
    type: Array,
    default: () => [],
  },
  sections: {
    type: Array,
    default: () => [],
  },
  imageMap: {
    type: Object,
    default: () => ({}),
  },
})

const {t} = useI18n()

const expandedSections = reactive(
  Object.fromEntries(
    props.sections.map((section) => [section.id, section.defaultExpanded !== false]),
  ),
)

const titleList = computed(() =>
  props.sections.map((section) => ({
    id: section.id,
    title: t(section.titleKey),
    href: `#${section.id}`,
    isExpanded: expandedSections[section.id],
    childList: [],
  })),
)
</script>

<style lang="less" scoped>
@import "../index";

.setting-guide-page {
  width: 100%;
  padding-bottom: 48px;
}

.setting-guide-page__spacer {
  width: 100%;
  height: 50px;
  margin-top: 30px;
}

.setting-guide-page__section {
  margin-top: 30px;
}

.setting-guide-page__section-content {
  padding-top: 8px;
}

:deep(.el-icon) {
  font-size: 16px !important;
}
</style>
